import { render, staticRenderFns } from "./WYSIWYG.vue?vue&type=template&id=3be53390&scoped=true&"
import script from "./WYSIWYG.vue?vue&type=script&lang=ts&"
export * from "./WYSIWYG.vue?vue&type=script&lang=ts&"
import style0 from "./WYSIWYG.vue?vue&type=style&index=0&id=3be53390&scoped=true&lang=scss&"
import style1 from "./WYSIWYG.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be53390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VIcon,VProgressLinear})
